import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { Header, SideNavbar, Footer } from "../components";
import { ConfirmDialogeProvider } from "../Services/Confirmation";
import { pageTabTitle } from "../Services/DateFunc";
import { Helmet } from "react-helmet";
import Modal from "../Services/Modal";
import { closeModal, OpenModal, setMainLoading } from "../Store/reducers/Common";
import { Scanner } from "@yudiel/react-qr-scanner";
import { PostAxios, responseCatchFunc } from "../Services/RequestService";
import { setToastData } from "../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../Services/Common";
import { useState } from "react";

export default function MainLayout() {
  const { isMainLoading, pageTitle, modalOpen } = useSelector(
    (state) => state.common
  );
  const { showToast, confirmDisplay } = useSelector((state) => state.toast);
  const [qrScannerPopup, openQrScannerPopup] = useState(false);
  const { userData, accessToken } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const markAttendance = (attendanceStatus, userId, userDiv,qr_id) => {
    dispatch(setMainLoading(true));
    PostAxios(`event/mark-attendance`, {
        event_id: qr_id,
        mem_id: userId,
        attendance_response: attendanceStatus,
        div_id: userDiv
    }, accessToken)
        .then(({ data }) => {
            console.log(data.errors);
            if (data.status === "1") {
                dispatch(setToastData({ message: `${data.message} `, isHtml: true, type: 'success', showCloseBtn: true }))
            }
            else {
                dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
            }
        })
        .catch((err) => {
            responseCatchFunc(dispatch, err);
        })
        .finally(() => {
            dispatch(setMainLoading(false));
        })
}
  return (
    <>
      {isMainLoading && (
        <div className="loading-img">
          <span className="loading-span">
            <svg className="circular" viewBox="25 25 50 50">
              <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="5" strokeMiterlimit="10" />
            </svg>
          </span>
        </div>
      )}
      <section
        className={`wrapper ${showToast || confirmDisplay || modalOpen ? "popup-open" : ""
          }`}
      >
        <Helmet>
          <title>{pageTabTitle(pageTitle)}</title>
        </Helmet>
        <ConfirmDialogeProvider>
          <Header />
          <div className={`mian-sec`}>
            <SideNavbar />
            <div className="right-sec-main">
              <h2 className="page-heading">{pageTitle !== "Page not found" && pageTitle}</h2>
              <Outlet />
            </div>
          </div>
          <Footer />
        </ConfirmDialogeProvider>
        {/* <button className="btn btn-blue floating-btn" onClick={()=>{
          openQrScannerPopup(true);
          dispatch(OpenModal())
        }}><i className="fas fa-qrcode"></i></button>
        {
            qrScannerPopup === true && <Modal classList="popup-main invoice-popup" style={{ maxWidth: 400, minHeight: 500, width: '100%' }} onClose={() => {
                openQrScannerPopup(false);
            }}>
                <Scanner onScan={(result) => {
                    console.log(result);
                    dispatch(closeModal())
                    openQrScannerPopup(false);
                    markAttendance(1, userData.id, userData.user_div,result[0].rawValue);
                }} />
            </Modal>
        } */}
      </section>
    </>
  );
}
